export const ADD_TO_HISTORY = 'ADD_TO_HISTORY';
export const SET_HISTORY_DATA = 'SET_HISTORY_DATA';
